export const API_URL = process.env.API_URL
export const API_VERSION = process.env.API_VERSION

export const TIME_URL = process.env.TIME_URL

export const ABLY_SCHEDULE_UPDATES_SUBSCRIBER_API_KEY = process.env.ABLY_SCHEDULE_UPDATES_SUBSCRIBER_API_KEY;
export const ABLY_KEY = process.env.ABLY_KEY;